// Cookiefirst
import config from "../config";
import { customLog } from "../js/customlog.js";
import { formConfig } from '@/js/formConfig.js';

const log = (str, type) => {
	if ( config.isAdminNavAllowed ){
		customLog(str, type);
	}
} 

export default {
	data() {return {
		/* ========================================================== */
		// Example: https://consent.cookiefirst.com/sites/production-highactionsv2.highco.be-6c666b66-66cb-6bbb-ab66-6a6cb66fd66e/consent.js
		cookieFirstUrl: "https://consent.cookiefirst.com/sites/production-highactionsv2.highco.be-0b3c578e-57f7-43eb-8d2f-a3cafb4f7ef0/consent.js"
		/* ========================================================== */
	}},

	methods: {
		putCookieFirstScriptInPlace(){
			if(this.cookieFirstUrl){
				log("--- COOKIEFIRST --------------------------------------");
				const script = document.createElement('script');
				script.innerHTML = ``; // ?
				script.setAttribute('src', this.cookieFirstUrl);
				document.body.prepend(script);
				log("--- …deployed --------------------------------------");
			}else{
				log("⚠️⚠️⚠️ NO COOKIEFIRST CONFIGURED ⚠️⚠️⚠️", 'red'); //non-visible in prod because "clear" & log
			}
		},
	},

	beforeMount() {
		/* If I'm in production and not on PnG action */
		if(config.isWebsiteInProduction && !formConfig.isPnGAction){
			this.putCookieFirstScriptInPlace();
		}
	}
}
